<template>
    <div class="modal fade custom-right-modal" id="notesModal">
        <div class="modal-dialog" style="max-width: 90% !important;">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Notes</h4>
                    <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body" v-if="quotation !=null">
                    <div class="alert alert-success" role="alert" v-if="successMessage">
                        {{ successMessage }}
                    </div>
                    <div v-if="errorMessage" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li>{{ errorMessage }}</li>
                        </ul>
                    </div>
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <form>
                            <div class="form-group">
                                <label for="exampleFormControlInput1">Description</label>
                                <textarea row="15" class="form-control" id="exampleFormControlInput1"
                                          placeholder="" v-model="form.notes"></textarea>

                            </div>
                            <button type="button" :class="[loading ? 'disabled':'']" v-on:click="save()" class="btn btn-primary close-modal">
                                Submit
                            </button>
                            <hr>
                        </form>
                        <div class="new-noteAdd" v-if="quote_notes">
                            <template v-for="(note, index) in quote_notes">
                                <div class="task-bg" v-if="note.type != 'reason'">
                                    <div class="edit-note">
                                        <div class="small-heading" v-if="edit_id!=note.id">{{ note.description }}</div>
                                        <div class="d-flex" v-if="edit_id==note.id">
                                            <input type="text" class="form-control" placeholder="" v-model="quote_notes[index].notes" >
                                            <a href="javascript:void(0);" @click="updateNote(note.notes, note.id)" class="text-primary" style="font-size: 18px"><i class="ri-save-3-fill"></i></a>
                                            <a href="javascript:void(0);" @click="edit_id=null" class="text-danger" style="font-size: 18px"><i class="ri-close-line"></i></a>
                                        </div>
                                    </div>
                                    <span class="pull-right lght-clr"><i  class="ri-calendar-event-fill me-1 align-bottom"></i> {{ note.post_time }}</span>
                                    <div class="modal-footer-sec">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <div class="light-clr">Created By {{
                                                    note.assign_name ? note.assign_name : ''
                                                }}
                                            </div>
                                        </div>
                                        <div class="flex-shrink-0">
                                            <a href="javascript:void(0)" @click="edit_id=note.id" style="font-size: 18px"><i class="ri-edit-box-line me-1"></i></a>
                                            <a href="javascript:void(0)" @click="deleteNote(note.id)" class="text-danger" style="font-size: 18px"><i class="ri-delete-bin-6-line"></i></a>
                                        </div>
                                    </div>
                                    </div>

                                </div>
                            </template>

                            <div v-if="quote_notes.length == 0" class="modal-body note-no">
                                <center>No Note found</center>
                            </div>
                        </div>
                    </div>


                </div>

                <!-- Modal footer -->
                <div class="modal-footer">

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Vue from "vue";

export default {
    name: "QuotationNotesModal",
    props: ['quotation', 'quote_notes'],
    created() {

    },
    beforeMount() {
        if(this.quote_notes) {
            this.quote_notes.forEach((x, index) => {
               if(!x.notes) {
                   x.notes = x.description;
               }
            });
        }
    },
    mounted() {

    },
    data() {
        return {
            submitted: false,
            form: {
                quote_id: null,
                notes: null
            },
            edit_id: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        save() {
            this.form.quote_id = this.quotation.id;

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('addNotes');

            return axios.post(apiUrl, this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        self.form.notes = null;
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.$emit('noteAddedEvent', data.data);
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        updateNote(notes, id) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('editNotes', {id: id});

            return axios.put(apiUrl, {quote_id: this.quotation.id, notes: notes}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        self.edit_id = null;
                        self.form.notes = null;
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.$emit('noteUpdatedEvent', data.data);
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteNote(id) {
            let self = this;
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete note?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        this.setLoading(true);
                        this.setCommonErrors([]);
                        this.setErrorMessage(null);

                        let apiUrl = window.route('deleteNotes', {id: id});

                        return axios.delete(apiUrl,  {
                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.data) {
                                    self.setSuccessMessage(data.message);
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                    this.$emit('noteUpdatedEvent', data.data);
                                } else {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                    }

                }
            });


        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
